import { Tablet } from '@maxpreps/shared/corecomponents/ScreenSize/ScreenSize';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import React from 'react';
import { IClientContest } from '../../../utils/schedule/serializeSchedule';
import ScheduleCheckboxCell from './ScheduleCheckboxCell';
import ScheduleDateTimeCell from './ScheduleDateTimeCell';
import ScheduleEditCell from './ScheduleEditCell';
import ScheduleMainCell from './ScheduleMainCell';
import ScheduleMascot from './ScheduleMascot';
import ScheduleResultsCell from './ScheduleResultsCell';

interface IScheduleRowProps {
  contest: IClientContest;
}

const ScheduleRow: React.FC<IScheduleRowProps> = ({ contest }) => {
  const isAdmin = useIsAdmin();

  return (
    <tr className={contest.isDeleted ? 'highlight-deleted' : ''}>
      {isAdmin && (
        <Tablet andAbove>
          <ScheduleCheckboxCell contest={contest} />
        </Tablet>
      )}
      <ScheduleDateTimeCell contest={contest} />
      <Tablet andAbove>
        <td>
          <ScheduleMascot contest={contest} />
        </td>
      </Tablet>
      <ScheduleMainCell contest={contest} />
      <ScheduleResultsCell contest={contest} />
      {isAdmin && <ScheduleEditCell contest={contest} />}
    </tr>
  );
};

export default ScheduleRow;
